export { default as InvestNow } from './InvestNow'
